import React from "react";
import { lightenColor } from "../utils/colors";

type TypePillProps = {
  label: string;
  color?: string;
};

export const TypePill: React.FC<TypePillProps> = ({
  label,
  color = "#6b7280",
}) => {
  return (
    <span
      className="card-type-pill"
      style={{
        backgroundColor: lightenColor(color, 85),
        color: color,
      }}
    >
      {label}
    </span>
  );
};
